const CAREER_COACHING_SERVICES = {
    'Student': {
        bundles: [
            {
                 title: 'Ultimate Bundle',
                 description: "The full package! We'll take you from planning your career all the way to practicing for the final interview.",
                 save: 'Save $195',
                 isMostPopular: true,
                 services: [
                    {
                        title: 'Career Consulting',
                    },
                    {
                        title: 'Resume Revision',
                    },
                    {
                        title: 'LinkedIn Profile Revision,',
                    },
                    {
                        title: 'AutoApply to Jobs',
                    },
                    {
                        title: 'Job Search Strategy',
                    },
                    {
                        title: 'Interview Prep and Continued Support',
                    },
                 ],
                 paymentInfo: '$699 or $29 per payment in 24 installments (US only)',
                 componentId: 'product-component-1715943915937',
                 productId: '7005708648634'
            },
            {
                title: 'Land the Job Bundle',
                description: "Identify your dream job and target it with a new resume and LinkedIn profile. Then we'll teach you how to network while we apply to 50 jobs for you!",
                save: 'Save $146',
                services: [
                    {
                        title: 'Career Consulting',
                    },
                    {
                        title: 'Resume Revision',
                    },
                    {
                        title: 'LinkedIn Profile Revision',
                    },
                    {
                        title: 'AutoApply to Jobs',
                    },
                    {
                        title: 'Job Search Strategy',
                    },
                    {
                        title: 'Continued Support',
                    },
                ],
                paymentInfo: '$599 or $25 per payment in 24 installments (US only)',
                componentId: 'product-component-1715943810870',
                productId: '7005706813626'
           },
           {
                title: 'Starter Bundle',
                description: 'Discover your dream job, target it with a tailored resume, and demonstrate your qualifications with a professional LinkedIn profile. All with 1-on-1 help!',
                save: 'Save $48',
                services: [
                    {
                        title: 'Career Consulting',
                        isPopular: true,
                    },
                    {
                        title: 'Resume Revision',
                    },
                    {
                        title: 'LinkedIn Profile Revision',
                    },
                ],
                paymentInfo: '$399 or $ 17 per payment in 24 installments (US only)',
                componentId: 'product-component-1715943880787',
                productId: '7005706256570'
            },
        ],
        individualServicesPrice: "$149 or $48 per payment in 4 installments (US only)",
        individualServices: [
            {
                title: 'Resume Revision',
                description: "We'll build your resume from the ground up to target your dream role.",
                type: 'resume-revision',
                isPopular: true,
                componentId: 'product-component-1715943856069',
                productId: '6580580909242'
            },
            {
                title: 'Career Consulting',
                description: "Discover your dream career with expert guidance.",
                type: 'career-consulting',
                componentId: 'product-component-1715943509190',
                productId: '7005698687162'
            },
            {
                title: 'LinkedIn Profile Revision',
                description: "Show employers you’re the perfect candidate with a better profile.",
                type: 'linkedin',
                componentId: 'product-component-1715943833692',
                productId: '6580993228986'
            },
            {
                title: 'Auto Apply to Jobs',
                description: "Sit back and relax while we apply to jobs for you.",
                type: 'auto-apply',
                componentId: 'product-component-1715943468558',
                productId: '6996049952954'
            },
            {
                title: 'Job Search Strategy',
                description: "Optimize your networking strategies to get the best referrals.",
                type: 'job-search',
                componentId: 'product-component-1715943779439',
                productId: '6580983333050'
            },
            {
                title: 'Interview Prep',
                description: "Our experts will train you to ace your behavioral interviews.",
                type: 'interview',
                componentId: 'product-component-1715943675641',
                productId: '6581001486522'
            }
        ],
        buttons_map: [
            {   
                componentId: 'product-component-1715943915937',
                productId: '7005708648634'
            },
            {
                componentId: 'product-component-1715943810870',
                productId: '7005706813626'
            },
            {
                componentId: 'product-component-1715943880787',
                productId: '7005706256570'
            },
            {
                componentId: 'product-component-1715943856069',
                productId: '6580580909242'
            },
            {
                componentId: 'product-component-1715943509190',
                productId: '7005698687162'
            },
            {
                componentId: 'product-component-1715943833692',
                productId: '6580993228986'
            },
            {
                componentId: 'product-component-1715943468558',
                productId: '6996049952954'
            },
            {
                componentId: 'product-component-1715943779439',
                productId: '6580983333050'
            },
            {
                componentId: 'product-component-1715943675641',
                productId: '6581001486522'
            },
        ]
    },
    'Early Career': {
        bundles: [
            {
                title: 'Ultimate Bundle',
                description: "The full package! We'll take you from planning your career all the way to practicing for the final interview.",
                save: 'Save $395',
                isMostPopular: true,
                services: [
                   {
                       title: 'Career Consulting',
                   },
                   {
                       title: 'Resume Revision',
                   },
                   {
                       title: 'LinkedIn Profile Revision',
                   },
                   {
                       title: 'AutoApply to Jobs',
                   },
                   {
                       title: 'Job Search Strategy',
                   },
                   {
                       title: 'Interview Prep and Continued Support',
                   },
                ],
                paymentInfo: '$1399 or $58 per payment in 24 installments (US only)',
                componentId: 'product-component-1715942897016',
                productId: '7005714809018'
           },
           {
                title: 'Land the Job Bundle',
                description: "Identify your dream job and target it with a new resume and LinkedIn profile. Then we'll teach you how to network while we apply to 50 jobs for you!",
                save: 'Save $296',
                services: [
                    {
                        title: 'Career Consulting',
                    },
                    {
                        title: 'Resume Revision',
                    },
                    {
                        title: 'LinkedIn Profile Revision',
                    },
                    {
                        title: 'AutoApply to Jobs',
                    },
                    {
                        title: 'Job Search Strategy',
                    },
                    {
                        title: 'and Continued Support',
                    },
                ],
                paymentInfo: '$1199 or $50 per payment in 24 installments (US only)',
                componentId: 'product-component-1715942710566',
                productId: '7005713367226'
            },
            {
                title: 'Starter Bundle',
                description: "Discover your dream job, target it with a tailored resume, and demonstrate your qualifications with a professional LinkedIn profile. All with 1-on-1 help!",
                save: 'Save $98',
                services: [
                    {
                        title: 'Career Consulting',
                    },
                    {
                        title: 'Resume Revision',
                    },
                    {
                        title: 'and LinkedIn Profile Revision.',
                    },
                ],
                paymentInfo: '$1199 or $50 per payment in 24 installments (US only)',
                componentId: 'product-component-1715942870285',
                productId: '7005712548026'
            },
        ],
        individualServicesPrice: "$299 or $75 per payment in 4 installments (US only)",
        individualServices: [
            {
                title: 'Resume Revision',
                description: "We'll build your resume from the ground up to target your dream role.",
                type: 'resume-revision',
                isPopular: true,
                componentId: 'product-component-1715942821704',
                productId: '6581008498874'
            },
            {
                title: 'Career Consulting',
                description: "Discover your dream career with expert guidance.",
                type: 'career-consulting',
                componentId: 'product-component-1715942093556',
                productId: '7005700653242'
            },
            {
                title: 'LinkedIn Profile Revision',
                description: "Show employers you’re the perfect candidate with a better profile.",
                type: 'linkedin',
                componentId: 'product-component-1715942752167',
                productId: '6581030518970'
            },
            {
                title: 'Auto Apply to Jobs',
                description: "Sit back and relax while we apply to jobs for you.",
                type: 'auto-apply',
                componentId: 'product-component-1715888341227',
                productId: '6996050804922'
            },
            {
                title: 'Job Search Strategy',
                description: "Optimize your networking strategies to get the best referrals.",
                type: 'job-search',
                componentId: 'product-component-1715942605615',
                productId: '6581009973434'
            },
            {
                title: 'Interview Prep',
                description: "Our experts will train you to ace your behavioral interviews.",
                type: 'interview',
                componentId: 'product-component-1715942415572',
                productId: '6581013610682'
            }
        ],
        buttons_map: [
            {
                componentId: 'product-component-1715942897016',
                productId: '7005714809018'
            },
            {
                componentId: 'product-component-1715942710566',
                productId: '7005713367226'
            },
            {
                componentId: 'product-component-1715942870285',
                productId: '7005712548026'
            },
            {
                componentId: 'product-component-1715942821704',
                productId: '6581008498874'
            },
            {
                componentId: 'product-component-1715942093556',
                productId: '7005700653242'
            },
            {
                componentId: 'product-component-1715942415572',
                productId: '6581013610682'
            },
            {
                componentId: 'product-component-1715942605615',
                productId: '6581009973434'
            },
            {
                componentId: 'product-component-1715888341227',
                productId: '6996050804922'
            },
            {
                componentId: 'product-component-1715942752167',
                productId: '6581030518970'
            },
        ]
    },
    'Not Working': {
        bundles: [
            {
                title: 'Ultimate Bundle',
                description: "The full package! We'll take you from planning your career all the way to practicing for the final interview.",
                save: 'Save $395',
                isMostPopular: true,
                services: [
                   {
                       title: 'Career Consulting',
                   },
                   {
                       title: 'Resume Revision',
                   },
                   {
                       title: 'LinkedIn Profile Revision',
                   },
                   {
                       title: 'AutoApply to Jobs',
                   },
                   {
                       title: 'Job Search Strategy',
                   },
                   {
                       title: 'Interview Prep and Continued Support',
                   },
                ],
                paymentInfo: '$1399 or $58 per payment in 24 installments (US only)',
                componentId: 'product-component-1715942897016',
                productId: '7005714809018'
           },
           {
                title: 'Land the Job Bundle',
                description: "Identify your dream job and target it with a new resume and LinkedIn profile. Then we'll teach you how to network while we apply to 50 jobs for you!",
                save: 'Save $296',
                services: [
                    {
                        title: 'Career Consulting',
                    },
                    {
                        title: 'Resume Revision',
                    },
                    {
                        title: 'LinkedIn Profile Revision',
                    },
                    {
                        title: 'AutoApply to Jobs',
                    },
                    {
                        title: 'Job Search Strategy',
                    },
                    {
                        title: 'and Continued Support',
                    },
                ],
                paymentInfo: '$1199 or $50 per payment in 24 installments (US only)',
                componentId: 'product-component-1715942710566',
                productId: '7005713367226'
            },
            {
                title: 'Starter Bundle',
                description: "Discover your dream job, target it with a tailored resume, and demonstrate your qualifications with a professional LinkedIn profile. All with 1-on-1 help!",
                save: 'Save $98',
                services: [
                    {
                        title: 'Career Consulting',
                    },
                    {
                        title: 'Resume Revision',
                    },
                    {
                        title: 'and LinkedIn Profile Revision.',
                    },
                ],
                paymentInfo: '$1199 or $50 per payment in 24 installments (US only)',
                componentId: 'product-component-1715942870285',
                productId: '7005712548026'
            },
        ],
        individualServicesPrice: "$299 or $75 per payment in 4 installments (US only)",
        individualServices: [
            {
                title: 'Resume Revision',
                description: "We'll build your resume from the ground up to target your dream role.",
                type: 'resume-revision',
                isPopular: true,
                componentId: 'product-component-1715942821704',
                productId: '6581008498874'
            },
            {
                title: 'Career Consulting',
                description: "Discover your dream career with expert guidance.",
                type: 'career-consulting',
                componentId: 'product-component-1715942093556',
                productId: '7005700653242'
            },
            {
                title: 'LinkedIn Profile Revision',
                description: "Show employers you’re the perfect candidate with a better profile.",
                type: 'linkedin',
                componentId: 'product-component-1715942752167',
                productId: '6581030518970'
            },
            {
                title: 'Auto Apply to Jobs',
                description: "Sit back and relax while we apply to jobs for you.",
                type: 'auto-apply',
                componentId: 'product-component-1715888341227',
                productId: '6996050804922'
            },
            {
                title: 'Job Search Strategy',
                description: "Optimize your networking strategies to get the best referrals.",
                type: 'job-search',
                componentId: 'product-component-1715942605615',
                productId: '6581009973434'
            },
            {
                title: 'Interview Prep',
                description: "Our experts will train you to ace your behavioral interviews.",
                type: 'interview',
                componentId: 'product-component-1715942415572',
                productId: '6581013610682'
            }
        ],
        buttons_map: [
            {
                componentId: 'product-component-1715942897016',
                productId: '7005714809018'
            },
            {
                componentId: 'product-component-1715942710566',
                productId: '7005713367226'
            },
            {
                componentId: 'product-component-1715942870285',
                productId: '7005712548026'
            },
            {
                componentId: 'product-component-1715942821704',
                productId: '6581008498874'
            },
            {
                componentId: 'product-component-1715942093556',
                productId: '7005700653242'
            },
            {
                componentId: 'product-component-1715942415572',
                productId: '6581013610682'
            },
            {
                componentId: 'product-component-1715942605615',
                productId: '6581009973434'
            },
            {
                componentId: 'product-component-1715888341227',
                productId: '6996050804922'
            },
            {
                componentId: 'product-component-1715942752167',
                productId: '6581030518970'
            },
        ]
    },
    'Working Professional': {
        bundles: [
            {
                title: 'Ultimate Bundle',
                description: "The full package! We'll take you from planning your career all the way to practicing for the final interview.c",
                save: 'Save $695',
                isMostPopular: true,
                services: [
                   {
                       title: 'Career Consulting',
                   },
                   {
                       title: 'Resume Revision',
                   },
                   {
                       title: 'LinkedIn Profile Revision',
                   },
                   {
                       title: 'AutoApply to Jobs',
                   },
                   {
                       title: 'Job Search Strategy',
                   },
                   {
                       title: 'Interview Prep and Continued Support',
                   },
                ],
                paymentInfo: '$2299 or $96 per payment in 24 installments (US only)',
                componentId: 'product-component-1715942945451',

            },
            {
                title: 'Land the Job Bundle',
                description: "Identify your dream job and target it with a new resume and LinkedIn profile. Then we'll teach you how to network while we apply to 50 jobs for you!",
                save: 'Save $496',
                services: [
                   {
                       title: 'Career Consulting',
                   },
                   {
                       title: 'Resume Revision',
                   },
                   {
                       title: 'LinkedIn Profile Revision',
                   },
                   {
                       title: 'AutoApply to Jobs',
                   },
                   {
                       title: 'Job Search Strategy',
                   },
                   {
                       title: 'and Continued Support',
                   },
                ],
                paymentInfo: '$1999 or $83 per payment in 24 installments (US only)',
                componentId: 'product-component-1715943257320',
            },
            {
                title: 'Starter Bundle',
                description: "Discover your dream job, target it with a tailored resume, and demonstrate your qualifications with a professional LinkedIn profile. All with 1-on-1 help!",
                save: 'Save $198',
                services: [
                   {
                       title: 'Career Consulting',
                   },
                   {
                       title: 'Resume Revision',
                   },
                   {
                       title: 'and LinkedIn Profile Revision',
                   }
                ],
                paymentInfo: '$1299 or $ 54 per payment in 24 installments (US only)',
                componentId: 'product-component-1715943362875',
            },
        ],
        buttons_map: [
            {
                componentId: 'product-component-1715942945451',
                productId: '7005723295930'
            },
            {
                componentId: 'product-component-1715943257320',
                productId: '7005720543418'
            },
            {
                componentId: 'product-component-1715943362875',
                productId: '7005716381882'
            },
            {
                productId: '6581015806138',
                componentId: 'product-component-1715943339674'
            },
            {
                productId: '7005701734586',
                componentId: 'product-component-1715943128038'
            },
            {
                productId: '6581033304250',
                componentId: 'product-component-1715943284940'
            },
            {
                productId: '6996052181178',
                componentId: 'product-component-1715943046615'
            },
            {
                productId: '6581020033210',
                componentId: 'product-component-1715943197520'
            },
            {
                productId: '6581034287290',
                componentId: 'product-component-1715943156735'
            },

        ],
        individualServicesPrice: "$499 or $125 per payment in 4 installments (US only)",
        individualServices: [
            {
                title: 'Resume Revision',
                description: "We'll build your resume from the ground up to target your dream role.",
                type: 'resume-revision',
                isPopular: true,
                componentId: 'product-component-1715943339674'
            },
            {
                title: 'Career Consulting',
                description: "Discover your dream career with expert guidance.",
                type: 'career-consulting',
                componentId: 'product-component-1715943128038'
            },
            {
                title: 'LinkedIn Profile Revision',
                description: "Show employers you’re the perfect candidate with a better profile.",
                type: 'linkedin',
                componentId: 'product-component-1715943284940'
            },
            {
                title: 'Auto Apply to Jobs',
                description: "Sit back and relax while we apply to jobs for you.",
                type: 'auto-apply',
                componentId: 'product-component-1715943046615'
            },
            {
                title: 'Job Search Strategy',
                description: "Optimize your networking strategies to get the best referrals.",
                type: 'job-search',
                componentId: 'product-component-1715943197520'
            },
            {
                title: 'Interview Prep',
                description: "Our experts will train you to ace your behavioral interviews.",
                type: 'interview',
                componentId: 'product-component-1715943156735'
            }
        ]
    } 
}

export default CAREER_COACHING_SERVICES;
